import { render } from "./factory_stock.vue?vue&type=template&id=95f6daba&scoped=true"
import script from "./factory_stock.vue?vue&type=script&lang=js"
export * from "./factory_stock.vue?vue&type=script&lang=js"

import "./factory_stock.vue?vue&type=style&index=0&id=95f6daba&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f6daba"]])

export default __exports__